import { render, staticRenderFns } from "./DisableMemberCar.vue?vue&type=template&id=580b1d95&"
import script from "./DisableMemberCar.vue?vue&type=script&lang=js&"
export * from "./DisableMemberCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports